import { inject, observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { trans } from '../../../../common/utils';
import cx from 'classnames';
import { WithDropdown } from '../../../../components';


const MyFavoriteSportSelect = ({ store, searchValSport, setSearchValSport, }) => {
    const viewSize = store.site.status.viewSize;

    const [sportsList, setSportsList] = useState([
        {
            label: trans('All'),
            element: (
                <div className="my-favorite__sport-picker-item">
                    <i className={`my-favorite__sport-picker-item-icon doruk-sports-menu-01`}></i>
                    <span>{trans('All')}</span>
                </div>
            ),
            id: 0,
        },
    ]);

    useEffect(() => {
        const list = [
            {
                label: trans('All'),
                element: (
                    <div className="my-favorite__sport-picker-item">
                        <i className={`my-favorite__sport-picker-item-icon doruk-sports-menu-01`}></i>
                        <span>{trans('All')}</span>
                    </div>
                ),
                id: 0,
            },
        ];
        store.betting.branch.sportsList.forEach((sport) => {
            list.push({
                label: sport.name,
                element: (
                    <div className="my-favorite__sport-picker-item">
                        <i className={`my-favorite__sport-picker-item-icon sport_icon_font-${sport.id}`}></i>
                        <span>{sport.name}</span>
                    </div>
                ),
                id: sport.id,
            });
        });
        setSearchValSport(list[0]);
        setSportsList(list);
    }, [store.betting.branch.sportsList?.length]);

    return (
        <div className={cx('my-favorite__sport-picker', `my-favorite__sport-picker--${viewSize}`)}>
            <WithDropdown
                dataSource={{ submenu: sportsList }}
                openBehavior="click"
                menuItemIsActive={(sport) => sport.id === searchValSport.id}
                onMenuItemClick={(sport) => {
                    store.site.status.setBackdropShown(false);
                    setSearchValSport(sport);
                }}
                menuClasses="my-favorite__sport-picker-dropdown"
                delay={500}
                placement="bottom-start"
            >
                <span
                    onClick={() => {
                        store.site.status.setBackDropFullScreen(false);
                        store.site.status.setBackdropShown(true);
                    }}
                >
                    {searchValSport?.label ?? trans('All')}
                </span>
            </WithDropdown>
        </div>
    );
};

export default inject('store')(observer(MyFavoriteSportSelect));